
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vision-mission",
      function () {
        return require("private-next-pages/vision-mission.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vision-mission"])
      });
    }
  